<template>
  <el-form ref="form" :rules="rules" :model="form" label-width="80px">
    <el-form-item label="新密码" prop="new_password">
      <el-input
        v-model="form.new_password"
        placeholder="请输入"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item style="text-align: right">
      <el-button @click="onCancel" :disabled="submitting">取 消</el-button>
      <el-button
        type="warning"
        @click="submitForm('form')"
        :loading="submitting"
        >提交修改</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { PutUserPasswordById } from "../api";
import { ShowApiError } from "@/request/error";
export default {
  props: {
    id: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      submitting: false,
      form: {
        new_password: "",
      },
      rules: {
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          PutUserPasswordById([
            {
              id: this.id,
              ...this.form,
            },
          ])
            .then(() => {
              this.submitting = false;
              this.form.new_password = "";
              this.$message.success("修改成功!");
              this.onEmitSuccess();
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError("修改失败", err);
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    onCancel() {
      this.form.new_password = "";
      this.$emit("cancel");
    },
    onEmitSuccess() {
      this.$emit("success");
    },
  },
};
</script>

<style lang="scss" scoped></style>
